import * as vp from 'vopay';
import { useContext, useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import AccountContext from '../Accounts/AccountContext';
import InteracBulkPayoutTransactionInfo from './InteracBulkPayoutTransactionInfo';
import useFetchInteracBulkPayoutTransaction from '../../hooks/useApi/useFetchInteracBulkPayoutTransaction';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const InteracBulkPayoutTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { TransactionID, Type } = props;
  const { details } = useContext(AccountContext);
  let token = '';
  if (details[accountId]) {
    token = details[accountId].token;
  }
  const [InteracBulkPayout, getInteracBulkPayoutTransaction] = useFetchInteracBulkPayoutTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.InteracBulkPayoutTransactionResponse>();

  useEffect(() => {
    if (Type === vp.TransactionType.INTERACT_BULK_PAYOUT) {
      getInteracBulkPayoutTransaction(TransactionID);
    }
  }, [currentTransactionId]);

  useEffect(() => {
    if (InteracBulkPayout) {
      setTransaction(InteracBulkPayout);
    }
  }, [InteracBulkPayout]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <InteracBulkPayoutTransactionInfo transaction={transaction} />}</div>;
};

export default InteracBulkPayoutTransactionContainer;
